import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';

import { InputProps } from '../props';

interface ComponentProps extends InputProps {
  labels?: [string, string];
}

const Switch: React.FC<ComponentProps> = ({ id, value, disabled = false, onChange, labels }) => {
  let label;
  if (labels) {
    label = value ? labels[1] : labels[0];
  } else {
    label = value ? 'YES' : 'NO';
  }

  return (
    <FormGroup switch data-cy={`${id}-switch`}>
      <Input
        id={id}
        type="switch"
        name="switch"
        checked={value ?? false}
        disabled={disabled}
        onChange={() => onChange && onChange(id, !value)}
      />
      <Label>{label}</Label>
    </FormGroup>
  );
};

export default Switch;
